import { Level, Location } from '@/core/entities';
import { FunctionComponent, ReactElement, useMemo } from 'react';
import { useLevelLocations } from '@/queries/locations';
import LocationFilter from './LocationFilter';

export interface RootLevelFilterProps {
	level?: Level;
	selectedLocation?: string;
	setLocation: (location?: Location) => void;
}

const RootLevelFilter: FunctionComponent<RootLevelFilterProps> = ({
	level,
	selectedLocation,
	setLocation,
}): ReactElement => {
	const { query } = useLevelLocations({ level });
	const { data: levelLocations, isFetching, isFetchingNextPage, fetchNextPage } = query;
	const { pages } = levelLocations || {};

	const locations = useMemo(() => pages?.flatMap((page) => page.locations.data), [pages]);

	return (
		<LocationFilter
			level={level}
			locations={locations}
			selectedLocation={selectedLocation}
			setLocation={setLocation}
			disabled={(isFetching && !isFetchingNextPage) || !locations}
			isLoadingOptions={isFetching && !isFetchingNextPage}
			isLoadingMoreOptions={isFetchingNextPage}
			/* eslint-disable @typescript-eslint/no-misused-promises */
			loadMoreOptions={() => fetchNextPage()}
		/>
	);
};

export default RootLevelFilter;
